export const initialData = {
  nome: '',
  cpf: '',
}
export default initialData;
  